export const zhCommon = {
  "language.menu": "选择语言",
  "language.english": "English",
  "language.chinese": "简体中文",
  "meta.title": "OURS — 社区共建的 Meme 发行平台",
  "meta.description":
    "OURS 是 Robinhood Chain 上由社区共同拥有的 Meme 发行平台",
  "common.loading": "OURS / 加载中",
  "toast.region": "通知",
  "toast.dismiss": "关闭通知",
  "toast.info": "提示",
  "toast.success": "成功",
  "toast.warning": "注意",
  "toast.error": "失败",
  "toast.loading": "处理中",
  "toast.copyFailed": "无法复制到剪贴板，请重试。",
  "update.available": "新版本已发布",
  "update.description": "刷新页面即可使用最新版本，请先完成当前操作。",
  "update.refresh": "刷新页面",
  "update.dismiss": "关闭更新提示",
  "error.notFoundEyebrow": "404 / OURS",
  "error.notFoundTitle": "这个页面还没有发行。",
  "error.notFoundDescription":
    "返回 Token 市场，继续发现 Robinhood Chain 上的新项目。",
  "error.backToExplore": "返回发现",
  "error.oursHome": "返回 OURS 首页",
  "error.systemStatus": "系统状态",
  "error.unexpectedEyebrow": "{{status}} / 暂时中断",
  "error.unexpectedTitle": "这一页暂时掉线了。",
  "error.unexpectedDescription":
    "你的操作没有问题。我们没能完成这次加载，请重新尝试，或返回发现页继续浏览。",
  "error.tryAgain": "重新尝试",
  "error.statusCode": "错误状态码 {{status}}",
  "error.reference": "错误编号",
  "error.time": "发生时间",
  "error.technicalDetails": "技术信息",
  "error.copyDetails": "复制诊断信息",
  "error.copied": "已复制",
  "error.copyFailed": "无法自动复制，请手动选择上方信息。",
  "error.supportHint":
    "如果问题持续出现，请将错误编号 {{reference}} 提供给支持团队。",
} as const;
